import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const EditFlow = () => import('./EditFlow.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flow-manager'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'Flow Manager',
        icon: 'content-settings',
        showNewButton: false,
      },
      children: [
        {
          path: 'flow/:typebotId/:flowId',
          name: 'flow_manager_edit',
          roles: ['administrator'],
          component: EditFlow,
          props: route => {
            return { contactId: route.params.contactId };
          },
        },
        {
          path: '',
          name: 'flow_manager_list',
          component: Index,
          roles: ['administrator'],
        }
      ],
    },
  ],
};
